import { render } from "./DietSummary.vue?vue&type=template&id=1c89503c"
import script from "./DietSummary.vue?vue&type=script&lang=js"
export * from "./DietSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__